/** Height in px of the shell bar over the top of the page, from `--shell-offset` on the root element; 0 when unset. */
export function shellOffsetPx(): number {
  const value = getComputedStyle(document.documentElement).getPropertyValue('--shell-offset');
  return Number.parseFloat(value) || 0;
}
